import styles from './index.module.scss'
import Utils from '@utils/utils'
import { useState } from 'react'
import { ProjectContext } from '../../hooks/ProjectContext'
import { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { AppContext } from '@utils/AppContext';

const list = [{
    title: 'AI商拍图',
    key: 'model',
    img_nomal: 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/pro_side_icon1_nomal.png',
    img_active: 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/pro_side_icon1_active.png',
},
// {
//     title: '商品版',
//     key: 'commodity',
//     img_nomal: 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/pro_side_icon2_nomal.png',
//     img_active: 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/pro_side_icon2_active.png',
// }, 
{
    title: 'AI视频',
    key: 'modelVideo',
    img_nomal: 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/pro_side_icon4_nomal.png',
    img_active: 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/pro_side_icon4_active.png',
}, {
    title: 'AI编辑',
    key: 'aiEdit',
    img_nomal: 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/pro_side_icon3_nomal.png',
    img_active: 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/pro_side_icon3_active.png',
}, {
    title: '企业版',
    key: 'bachImage',
    img_nomal: 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/batchImahe_nomal.png',
    img_active: 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/batchImahe_active.png',
}]

const ProjectSidebar = () => {
    const navigate = useNavigate();
    const {
        setProFunction
    } = useContext(ProjectContext)
    const { proSidebarValue, setProSidebarValue, } = useContext(AppContext);


    useEffect(() => {
        if (proSidebarValue == 'bachImage') {
            navigate(`/home/myProject/batchImages`, {
                state: {
                    isProCenter: true,
                }
            })
        }
    }, [proSidebarValue])

    const handleClick = (key) => {
        setProFunction('');
        setProSidebarValue(key)
        navigate(`/home/myProject/list`)
        if (key == 'bachImage') {
            navigate(`/home/myProject/batchImages`, {
                state: {
                    isProCenter: true,
                }
            })
        }
    }

    return (
        <div className={styles.ProjectSidebar}>
            {
                list.map((item) => (
                    <div
                        className={styles.ProjectSidebarItem}
                        key={item.key}
                        onClick={() => { handleClick(item.key) }}

                    >
                        <img src={Utils.getImgThumbnail(proSidebarValue == item.key ? item.img_active : item.img_nomal)} alt="" />
                        <p style={{color: proSidebarValue == item.key ? '#006EFF' : '#5B6673'}} >{item.title}</p>
                    </div>
                ))
            }
        </div>
    )
}

export default ProjectSidebar
